import { useNavigate } from "react-router-dom";

import ImageBannerOne from "../../assets/comandatuba/banner.jpg";
import ImageBannerTwo from "../../assets/clubmed/banner-responsive.jpg";

import { Banner, Container } from "./styles";

const NextEvents = () => {
  let navigate = useNavigate();

  return (
    <Container id="registration">
      <Banner
        src={ImageBannerOne}
        alt="banner"
        onClick={() => navigate("comandatuba")}
      />
      <Banner
        src={ImageBannerTwo}
        alt="banner"
        onClick={() => navigate("clubmed")}
      />
    </Container>
  );
};

export default NextEvents;
